import { cloneElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ButtonRadio } from '@/components'
import { Instance } from '@/models/instance'

import { InstanceAccess } from './InstanceAccess'
import { InstanceAccessWithPublicIP } from './InstanceAccessWithPublicIP'
import { InstanceBilling } from './InstanceBilling'
import { InstanceConfig } from './InstanceConfig'
import { InstanceHardware } from './InstanceHardware'

interface InstanceDetailProps {
  instance: Instance
  onUpdate?: () => void
  isRunning?: boolean
}

type Item = {
  label: string
  value: string
  Comp: JSX.Element
}

export function InstanceDetail({ instance, isRunning, onUpdate }: InstanceDetailProps) {
  const { t } = useTranslation()
  const accessItem = instance.isRunning
    ? {
        label: t('instance.detail.accessTitle'),
        value: 'Access',
        Comp:
          instance.nats && instance.nats.length > 0 ? (
            <InstanceAccessWithPublicIP instance={instance} onUpdate={onUpdate} />
          ) : (
            <InstanceAccess instance={instance} onUpdate={onUpdate} />
          ),
      }
    : undefined

  const billingItem =
    (instance.isRunning || instance.isReleased) && instance.displayID
      ? {
          label: t('instance.detail.billingTitle'),
          value: 'Billing',
          Comp: <InstanceBilling instance={instance} />,
        }
      : undefined

  const configItem = {
    label: t('instance.detail.configTitle'),
    value: 'Config',
    Comp: <InstanceConfig instance={instance} />,
  }

  const hardwareItem =
    instance.isRunning || instance.hardware
      ? {
          label: t('instance.detail.hardwareTitle'),
          value: 'Hardware',
          Comp: <InstanceHardware instance={instance} isRunning={isRunning} />,
        }
      : undefined

  const items: Item[] = [accessItem, billingItem, configItem, hardwareItem].filter(
    Boolean,
  ) as Item[]

  const [tab, setTab] = useState(items[0].value)

  return (
    <div>
      <div className="px-4">
        <ButtonRadio
          className="mb-2 "
          value={tab}
          items={items}
          onChange={(e) => setTab(e)}
          size={'small'}
        />

        {items.map((item) => tab === item.value && cloneElement(item.Comp, { key: item.value }))}
      </div>
    </div>
  )
}
